/** Отображает диалог с данными, получанными через AJAX
 *  
 *  Если диалог открывается из другого диалога, надо поставить уровень 2
 *  
 * @param {url} URL
 * @param {title} заголовок диалога
 * @param {param} ширина (по умолчанию 800) или набор параметров ({width: 800, modal: true})
 * @param {level} уровень (по умолчанию 1)
 */
function ajaxDialog(url, title, param) {
	var div = document.createElement("div");
	var par;
	if (typeof param == "string") {
		par = {width: param, modal: true};
	} else if (typeof param == "object") {
		par = param;
	} else {
		par = {};
	}
	if (!par.width)
		par.width = "800";
	//if (typeof par.modal == "undefined")
	par.modal = false;


//	$(div).html("<table class='centertable'><tr><td><img src='css/buttons/ajax_clock_small.gif'></td></tr></table>");
	document.body.appendChild(div);
	$(div).prop("title", title);
	$(div).css({"display": "none"});
	var shadower = $("<div class='shadower'><table class='centertable'><tr><td><img id=loadingbig src='img/loadingbig.gif'></td></tr></table></div>");

	if (typeof par.close == "undefined")
		par.close = function (event, ui) {
			$(div).remove();
			$(shadower).hide("fade", 200, function () {
				$(shadower).remove();
			});
		};
	$('body').append(shadower);
	$(shadower).height($(document).innerHeight()).width($(document).innerWidth()).show("fade", 200);
	jQuery.ajax(url, {
		cache: false,
		timeout: 5000,
		success:
			function (data) {
				if (data == "NOAUTH") {
					//ajaxDialog("authorize", "Авторизация", 300, level)
					data = "Не авторизованы!"
				}
				$(div).html(data);
				$("#loadingbig").remove();
				$(div).dialog(par);
				//$(shadower).on("click", function() {
				//	$(div).dialog("close");
				//});
			},
		error:
			function (jqXHR, textStatus, errorThrown) {
				aAlert("Ошибка получения данных: " + textStatus + " (" + errorThrown + ")").then(() => {
					$("#loadingbig").remove();
					$(div).remove();
					$(shadower).hide("fade", 200, function () {
						$(shadower).remove();
					});
				});
			}});
}

/** Получает данные через AJAX и запихивает их в элемен
 *  
 *  Если если приходит пустой ответ, то записывает содержание параметра nvl
 *  
 * @param {url} URL
 * @param {target} куда записать (селектор jQuery)
 * @param {nvl} замена пустого ответа
 */
function ajaxReload(url, target, nvl, callback) {
	jQuery.get(url, function (data) {
		if (data == "null" || data == null || data == "") {
			data = nvl;
		}
		jQuery(target).html(data);
		if (callback)
			callback();
	});
}

/** Получает JSON объект через AJAX и выполняет определенные действия
 *  
 *  Если в объекте есть свойство msg, то выводится сообщение.
 *  
 * @param {url} URL
 */
function ajaxJSON(url, callback) {
	return jQuery.get(url, function (callback) {
		return function (d) {
			var data = null;
			if (typeof (d) === "object") {
				data = d;
			} else {
				data = json(d);
			}
			if (data == null || data == "") {
				aAlert("Ошибка обработки запроса!");
				console.log("JSON parse error: " + d);
				return;
			}
			if (data.log) {
				console.log("JSON log: " + data.log);
			}
			if (data.msg) {
				aAlert(data.msg);
			}
			if (data.reload) {
				location.reload();
			}
			if (callback)
				callback(data);
		};
	}(callback));
}

/** Безопасный парсер JSON
 * 
 * Возвращает объект или null при ошибке
 * 
 * @param {String} строка с JSON
 * @returns {@exp;jQuery@call;parseJSON}
 */

function json(str) {
	try {
		return jQuery.parseJSON(str);
	} catch (c) {
		return null;
	}
}

function uuidv4() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

function makeAutocompleteSearch() {
	$("[searchUrl]").each(function (n, el) {
		var url = el.getAttribute("searchUrl");
		jQuery(el).val(htmlDecode(jQuery(el).val()));
		jQuery(el).autocomplete({
			source: url
		});
	});
}

function htmlDecode(value) {
	value = ("" + value).replace("<script", "").replace("&lt;script", "");
	return $('<div/>').html(value).text();
}

var aliveInterval = 60000;
function alive() {
	$.get("/alive", function (data) {
		try {
			if (data && data.i) {
				var i = parseInt(data.i);
				if (i < 60) {
					i = 60;
				}
				aliveInterval = i * 1000;
			}
		} catch (E) {

		}
	});
	setTimeout(alive, aliveInterval);
}

/**
 * Использование trim на элементе/элементах при потере фокуса
 * @param {type} elems
 * @returns {undefined}
 */
function useTrimOnBlur(elems) {
	if(!elems || !elems.jquery) {
		console.error("Ошибка. Не передан объект jquery");
		return;
	}
	
	$(elems).on('blur', function () {
		const value = $(this).val();
		$(this).val(value.trim());
			//.change(); // применяем trim и триггерим  change
	});
}

/**
 * Маскировка email
 * @param {String} email - почта
 * @returns {String} - *****@*****.ru
 */
function maskEmail(email) {
	const parts = email.split("@");
	if (parts.length !== 2) {
		return "*****"; // Неверный формат email
	}

	const domainParts = parts[1].split(".");
	if (domainParts.length < 2) {
		return "*****@*****"; // Нет TLD
	}
	const tld = domainParts.pop(); // Получаем TLD (например, 'com', 'ru')
	return `*****@*****.${tld}`;
}

/**
 * Маскировка phone
 * @param {String} phone - телефон
 * @returns {String} - **********30
 */
function maskPhone(phone) {
	return phone.slice(0, -2).replace(/./g, "*") + phone.slice(-2);
}

function validatePhone(phonenumber) {
	if (phonenumber.replace(/[^0-9.]/g, '').length < 11 || phonenumber.replace(/[^0-9.]/g, '').length > 11) {
		return false;
	} else {
		return true;
	}
}

function formatNumber(n, stripKop) {
	if (typeof n === "undefined") {
		return "";
	}
	if (typeof n === "string") {
		n = parseFloatEx(n);
	}
	var digits = n * 100 % 100 > 0 || !stripKop ? 2 : 0;

	return n.toLocaleString('ru-RU', {minimumFractionDigits: digits});
}

function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

/**
 * Валидация адреса 
 * не менее 3х слов
 * на бэке auth.hasValidAddr
 * @param {String} address
 * @returns {undefined}
 */
function validateAddr(address) {
	if (!address) {
		return false;
	}
	const val = address.split(" ");
	if(val.length < 3) {
		return false;
	}
	
	return true;
}


/**
 * Проверяет адрес на корректность по dadata
 * Проверка по уровню детализации адреса (fias_level)
 * 
 * https://dadata.ru/api/suggest/address/
 * 0 - страна, 
 * 1 - регион, 
 * 3 - район, 
 * 4 - город,
 * 5 - район города, 
 * 6 - населенный пункт, 
 * 7 - улица, 
 * 8 - дом, 
 * 9 - квартира или комната, 
 * 65 - планировочная структура, 
 * 75 - земельный участок, 
 * -1 - иностранный или пустой
 * 
 * @param suggestion - ответ по api dadata 
 * @param minRequiredLevel - минимальный требуемый уровень детализации адреса
 */
function checkAddressCompleteness(suggestion, minRequiredLevel = 7) {
	const data = suggestion.data;
	const fiasLevel = Number(data.fias_level); // уровень адреса

	if (fiasLevel < minRequiredLevel) { // если меньше минимального уровня
		return {
			isComplete: false,
			message: "Введите адрес полностью!",
			fiasLevel: fiasLevel,
		};
	} else {
		return {
			isComplete: true,
			message: "Адрес полный",
			fiasLevel: fiasLevel,
		};
	}
}

/**
 * Валидация почтового индекса
 * @param {String} value 
 * @param {String} error 
 * @returns {undefined}
 */
function validatePostalIndex(value, error) {
	if (!error) {
		error = {};
	}
	let result = false;
	if (typeof value === 'number') {
		value = value.toString();
	} else if (typeof value !== 'string') {
		value = '';
	}
	
	if (!value.length) {
		error.code = 1;
		error.message = 'Почтовый индекс пуст';
	} else if (/[^0-9]/.test(value)) {
		error.code = 2;
		error.message = 'Почтовый индекс может состоять только из цифр';
	} else if (value.length < 4 || value.length > 9) { // индексы из других стран разной длины
		error.code = 3;
		error.message = 'Некорректный почтовый индекс';
		//error.message = 'Почтовый индекс может состоять только из 6 цифр';
	} else {
		result = true;
	}
	return result;
}

/**
* Проверка ФИО (checkFIOpartNew в java)
* В соответствии с приказом ФНС:  https://www.consultant.ru/document/cons_doc_LAW_410788/763145d8bce1267a0501117c28ebd122104c1b8e/
* @param s - строка
* @return boolean
*/
function validateFIO(s) {
	if (s === null || s.trim() === "") {
		return false;
	}

	// Предварительные проверки
	if (
		s.endsWith(" .")
		|| // заканчивается пробел+точка
		s.endsWith("(")
		|| // заканчивается открывающей скобкой
		s.includes("  ")
		|| // два пробела подряд
		s.includes("--")
		|| // два дефиса подряд  
		s.includes("''")
		|| // два апострофа подряд
		s.includes(" .")
		|| // пробел перед точкой
		s.includes("- ")
		|| // пробел после дефиса
		s.includes(" -")
		) {
		return false;
	}

	// Основная проверка

	const russianLetters = "А-ЯЁа-яё";
	const romanNumerals = "IV";

	const pattern = "^[" + russianLetters + "]+"
		+ "("
		+ // Пробел + НЕ пробел
		"\\s[" + russianLetters + romanNumerals + "\\(\\)\\.]+" +
		"|" +
		// Дефис + НЕ дефис  
		"\-[" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
		"|" +
		// Апостроф + НЕ апостроф
		"\'[" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
		"|" +
		// Запятая + пробел + буквы (запятая всегда с пробелом)
		"\\,\\s[" + russianLetters + romanNumerals + "\\(\\)\\.]+" +
		"|" +
		// Скобки и точки + любые разрешенные символы
		"[\\(\\)\\.][" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
		")*$";

	const regex = new RegExp(pattern);
	return regex.test(s);
}

function validateEFRSB_id(id) {
	if (id.length != 7 && id.length != 8) {
		return false;
	} else {
		return true;
	}
}

function validateInn(inn, type, error) {
	if(typeof inn === 'object') {
		type = inn.org_type;
		error = inn.errorObj;
		inn = inn.value;
	}
	
	if(typeof type !== 'string') { // обратная совместимость
		error = type;
		type = undefined;
	}
	
	if (!error) {
		error = {};
	}
	var result = false;
	if (typeof inn === 'number') {
		inn = inn.toString();
	} else if (typeof inn !== 'string') {
		inn = '';
	}
	
	let requiredLen = [10, 12]; // если не указан тип то проверка и для фл и для юл
	switch (type) {
		case 'fiz':
			requiredLen = [12];
			break;
		case 'ur':
			requiredLen = [10];
			break;
	}
	
	if (!inn.length) {
		error.code = 1;
		error.message = 'ИНН пуст';
	} else if (/[^0-9]/.test(inn)) {
		error.code = 2;
		error.message = 'ИНН может состоять только из цифр';
	} else if (requiredLen.indexOf(inn.length) === -1) {
		error.code = 3;
		error.message = `ИНН может состоять только из ${requiredLen.length > 1 ? '10 или 12' : requiredLen[0]} цифр`;
	} else if (inn === '0000000000' || inn === '000000000000') {
		error.code = 4;
		error.message = 'ИНН не может состоять из нулей';
	} else {
		var checkDigit = function (inn, coefficients) {
			var n = 0;
			for (var i in coefficients) {
				n += coefficients[i] * inn[i];
			}
			return parseInt(n % 11 % 10);
		};
		switch (inn.length) {
			case 10:
				if(type === 'ur' || type === undefined) {
					var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
					if (n10 === parseInt(inn[9])) {
						result = true;
					}
				}
				
				break;
			case 12:
				if(type === 'fiz' || type === undefined) {
					var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
					var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
					if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
						result = true;
					}
				}
				
				break;
		}
		if (!result) {
			error.code = 4;
			error.message = 'Некорректный ИНН';
		}
	}
	return result;
}

function validateRs(rs, bik, error) {
	if (!error) {
		error = {};
	}
	var result = false;
	if (typeof rs === 'number') {
		rs = rs.toString();
	} else if (typeof rs !== 'string') {
		rs = '';
	}
	rs = rs.replace(/[\-\ ]/g, "");
	bik = bik.replace(/[\ ]/g, "");
	if (!rs.length) {
		error.code = 1;
		error.message = 'Счет пуст';
	} else if (/[^0-9]/.test(rs)) {
		error.code = 2;
		error.message = 'Счет может состоять только из цифр';
	} else if (rs.length !== 20) {
		error.code = 3;
		error.message = 'Счет может состоять только из 20 цифр';
	} else {
		if (rs.substr(0, 2) === "03") {
			//казначейский??
			return true;
		}

		var bikRs;
		if (bik.substring(6, 8) === "00") {
			bikRs = "0" + bik.substring(4, 6) + rs;
		} else {
			bikRs = bik.toString().slice(-3) + rs;
		}
		var checksum = 0;
		var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
		for (var i in coefficients) {
			checksum += coefficients[i] * (bikRs[i] % 10);
		}
		if (checksum % 10 === 0) {
			result = true;
		} else {
			error.code = 4;
			error.message = 'Неверно указан расчетный счет или БИК';
		}
	}
	return result;
}

function digitsOnly(s) {
	if (s == null) {
		return "";
	}
	return String(s).replace(/\D/g, "");
}

function hasIpNamePrefix(name) {
	if (typeof name !== "string") {
		return false;
	}
	var n = name.replace(/^\s+|\s+$/g, "").toLowerCase();
	return n.indexOf("ип ") === 0 || n.indexOf("индивидуальный") === 0;
}

function getRsNameError(rs, name) {
	var d = digitsOnly(rs);
	if (d.substr(0, 5) === "40802" && !hasIpNamePrefix(name)) {
		return "В наименовании получателя должно быть указано ИП, так как счет принадлежит ИП.";
	}
	if (d.substr(0, 5) !== "40802" && hasIpNamePrefix(name)) {
		if (d.length < 5) {
			return null;
		}
		if (d.substr(0, 5) === "40817") {
			return "Счет принадлежит физическому лицу, уберите ИП из наименования получателя";
		}
		return "Счет принадлежит юридическому лицу, уберите ИП из наименования получателя";
	}
	return null;
}

function stripIpPrefix(name) {
	if (typeof name !== "string") {
		return name;
	}
	var trimmed = name.replace(/^\s+/, "");
	if (trimmed.toLowerCase().indexOf("ип ") === 0) {
		return trimmed.substring(3).replace(/^\s+/, "");
	}
	return name;
}

function applyIpPrefixByRs(rs, name) {
	var d = digitsOnly(rs);
	if (d.length < 5) {
		return name;
	}
	if (d.substr(0, 5) === "40802") {
		if (hasIpNamePrefix(name)) {
			return name;
		}
		var n = (name || "").replace(/^\s+|\s+$/g, "");
		return "ИП " + n;
	}
	if (d.substr(0, 5) === "40817") {
		return name;
	}
	return stripIpPrefix(name);
}

function syncDkpIpCheckbox(formSel, rs) {
	var $cb = $("[name=dkp_is_ip]", formSel);
	if (!$cb.length) {
		return;
	}
	var d = digitsOnly(rs);
	if (d.length < 5) {
		return;
	}
	if (d.substr(0, 5) === "40802") {
		$cb.prop("checked", true);
	} else if (d.substr(0, 5) !== "40817") {
		$cb.prop("checked", false);
	}
}

function onDkpIpCheckboxChange() {
	if (typeof updateRecipientFromOwner === "function") {
		updateRecipientFromOwner();
	}
	var $title = $("[name=dkp_recipient_name]");
	var $cb = $("[name=dkp_is_ip]");
	if (!$title.length || !$cb.length) {
		return;
	}
	if ($cb.prop("checked")) {
		if (!hasIpNamePrefix($title.val())) {
			var n = ($title.val() || "").replace(/^\s+|\s+$/g, "");
			$title.val("ИП " + n);
		}
	} else {
		$title.val(stripIpPrefix($title.val()));
	}
}

function bindIpPrefixAutoFill(formSel, rsName, titleName) {
	var $rs = $("[name=" + rsName + "]", formSel);
	var $title = $("[name=" + titleName + "]", formSel);
	if (!$rs.length || !$title.length) {
		return;
	}
	$rs.on("input change", function () {
		if ($title.prop("disabled")) {
			return;
		}
		var next = applyIpPrefixByRs($rs.val(), $title.val());
		if (next !== $title.val()) {
			$title.val(next);
		}
		if (titleName === "dkp_recipient_name") {
			syncDkpIpCheckbox(formSel, $rs.val());
		}
	});
}

function validateSnils(snils, error) {
	if (!error) {
		error = {};
	}
	var result = false;
	if (typeof snils === 'number') {
		snils = snils.toString();
	} else if (typeof snils !== 'string') {
		snils = '';
	}
	snils = snils.replace(/[\-\ ]/g, "");
	if (!snils.length) {
		error.code = 1;
		error.message = 'СНИЛС пуст';
	} else if (/[^0-9]/.test(snils)) {
		error.code = 2;
		error.message = 'СНИЛС может состоять только из цифр';
	} else if (snils.length !== 11) {
		error.code = 3;
		error.message = 'СНИЛС может состоять только из 11 цифр';
	} else {
		if (snils <= 100199800) {
			//Проверка контрольного числа Страхового номера проводится только для номеров больше номера 001-001-998
			return true;
		}
		var sum = 0;
		for (var i = 0; i < 9; i++) {
			sum += parseInt(snils[i]) * (9 - i);
		}
		var checkDigit = 0;
		if (sum < 100) {
			checkDigit = sum;
		} else if (sum > 101) {
			checkDigit = parseInt(sum % 101);
			if (checkDigit === 100) {
				checkDigit = 0;
			}
		}
		if (checkDigit === parseInt(snils.slice(-2))) {
			result = true;
		} else {
			error.code = 4;
			error.message = 'Неправильный СНИЛС';
		}
	}
	return result;
}


function validateKPP(kpp, error) {
	if (!error) {
		error = {};
	}
	var result = false;
	if (typeof kpp === 'number') {
		kpp = kpp.toString();
	} else if (typeof kpp !== 'string') {
		kpp = '';
	}
	if (!kpp.length) {
		error.code = 1;
		error.message = 'КПП пуст';
	} else if (kpp.length !== 9) {
		error.code = 2;
		error.message = 'КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)';
	} else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(kpp)) {
		error.code = 3;
		error.message = 'Неправильный формат КПП';
	} else {
		result = true;
	}
	return result;
}

function validateOgrnOrOgrnip(ogrn, error) {
	if (!error) {
		error = {};
	}
	if (typeof ogrn === 'number') {
		ogrn = ogrn.toString();
	} else if (typeof ogrn !== 'string') {
		ogrn = '';
	}
	if (!ogrn.length) {
		error.code = 1;
		error.message = 'ОГРН пуст';
		return false;
	} else if (/[^0-9]/.test(ogrn)) {
		error.code = 2;
		error.message = 'ОГРН может состоять только из цифр';
		return false;
	} else if (ogrn.length === 13) {
		return validateOgrn(ogrn, error);
	} else if (ogrn.length === 15) {
		return validateOgrnip(ogrn, error);
	}
	error.code = 3;
	error.message = 'ОГРН может состоять только из 13 или 15 цифр';
	return false;
}

function validateOgrn(ogrn, error) {
	if (!error) {
		error = {};
	}
	var result = false;
	if (typeof ogrn === 'number') {
		ogrn = ogrn.toString();
	} else if (typeof ogrn !== 'string') {
		ogrn = '';
	}
	if (!ogrn.length) {
		error.code = 1;
		error.message = 'ОГРН пуст';
	} else if (/[^0-9]/.test(ogrn)) {
		error.code = 2;
		error.message = 'ОГРН может состоять только из цифр';
	} else if (ogrn.length !== 13) {
		error.code = 3;
		error.message = 'ОГРН может состоять только из 13 цифр';
	} else if (ogrn === '0000000000' || ogrn === '000000000000') {
		error.code = 4;
		error.message = 'ОГРН не может состоять из нулей';
	} else {
		var n13 = parseInt((parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1));
		if (n13 === parseInt(ogrn[12])) {
			result = true;
		} else {
			error.code = 4;
			error.message = 'Некорректный ОГРН';
		}
	}
	return result;
}

function validateOgrnip(ogrnip, error) {
	if (!error) {
		error = {};
	}
	var result = false;
	if (typeof ogrnip === 'number') {
		ogrnip = ogrnip.toString();
	} else if (typeof ogrnip !== 'string') {
		ogrnip = '';
	}
	if (!ogrnip.length) {
		error.code = 1;
		error.message = 'ОГРНИП пуст';
	} else if (/[^0-9]/.test(ogrnip)) {
		error.code = 2;
		error.message = 'ОГРНИП может состоять только из цифр';
	} else if (ogrnip.length !== 15) {
		error.code = 3;
		error.message = 'ОГРНИП может состоять только из 15 цифр';
	} else if (ogrnip === '0000000000' || ogrnip === '000000000000') {
		error.code = 4;
		error.message = 'ОГРНИП не может состоять из нулей';
	} else {
		var n15 = parseInt((parseInt(ogrnip.slice(0, -1)) % 13).toString().slice(-1));
		if (n15 === parseInt(ogrnip[14])) {
			result = true;
		} else {
			error.code = 4;
			error.message = 'Некорректный ОГРНИП';
		}
	}
	return result;
}

function validateDate(s, error) {
	if (!error) {
		error = {};
	}
	var separators = ['\\.'];
	var bits = s.split(new RegExp(separators.join('|'), 'g'));
	var d = new Date(bits[2], bits[1] - 1, bits[0]);
	var ret = bits.length == 3 && d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
	if (ret) {
		return true;
	}
	error.message = "Неверный формат даты!";
	return false;
}

function parseFloatEx(s) {
	return parseFloat((s + "").replace(",", '.').replace(/&nbsp;/g, "").replace(/\s/g, "")).toFixed(2) * 1;
}

function scrollToElement(selector, delay) {
	if ($(selector).length === 0) {
		return;
	}
	if (!delay) {
		delay = 700;
	}
	$('html, body').animate({
		scrollTop: $(selector).filter(":visible").offset()["top"]
	}, delay);
}

(function (elmProto) {
	if ('scrollTopMax' in elmProto) {
		return;
	}
	Object.defineProperties(elmProto, {
		'scrollTopMax': {
			get: function scrollTopMax() {
				return this.scrollHeight - this.clientHeight;
			}
		},
		'scrollLeftMax': {
			get: function scrollLeftMax() {
				return this.scrollWidth - this.clientWidth;
			}
		}
	});
}
)(Element.prototype);


var musicOn = localStorage.getItem("musicOn") && localStorage.getItem("musicOn") !== null ? JSON.parse(localStorage.getItem("musicOn")) : true;
var browser = "hz";
var isie = false;//(navigator.appName.indexOf("Internet Explorer") != -1);
var isMobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(window.navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(window.navigator.userAgent.substr(0, 4)));
//id юзера для выбора сертифика выбранного ранее 
var auth_log = "";
var auth_user_id = "";

if (navigator.userAgent.match(/msie/i) || navigator.userAgent.match(/trident/i)) {
	browser = "ie";
	isie = true;
}
if (navigator.userAgent.match(/firefox/i)) {
	browser = "firefox";
}
if (navigator.userAgent.match(/chrome/i)) {
	browser = "chrome";
}
if (navigator.userAgent.match(/edge/i)) {
	browser = "edge";
}
if (navigator.userAgent.match(/yabrowser/i)) {
	browser = "yandex";
}
if (typeof opr == "object") {
	browser = "opera";
}

function goBackPage() {
	// Проверяем, есть ли предыдущая страница в истории
	if (document.referrer && document.referrer.indexOf(window.location.hostname) !== -1) {
		// Если referrer с того же домена - возвращаемся назад
		history.back();
	} else {
		// Иначе перенаправляем на главную страницу
		window.location.href = '/';
	}
}
function isMainPage() {
	const path = window.location.pathname;
	return path === '/' || path === '/index.html';
}

/*
 * Конвертирует значение в boolean, корректно обрабатывая строку.
 * @param {type} s
 * @returns {Boolean}
 */
function strToBool(s) {
	return !!s && s !== "0" && s.toString().toLowerCase() !== "false";
}

/** делаем из инпута шаблон для ввода телефона
 * 
 * @param {type} inp
 * @returns {Boolean}
 */
/*
function inputTel(inp, callback) {
	ii = inp;
	var prefix = '+7';
	var rawlen = 10;
	var tr = {};
	tr[0] = ' (';
	tr[3] = ') ';
	tr[6] = ' ';
	tr[8] = ' ';

	function rawize(s) {

		s = s.replace(/[^0-9]/g, '');

		if (s[0] === '8') {
			s = '+7' + s.substring(1);
			inp.value = s;
		}

		if (s[0] === '7') {
			s = '+7' + s.substring(1);
			inp.value = s;
		}

		if (s.length === '18') {
			s = s.substring(0, 17);
			inp.value = s;
		}

		//проверка начла ввода телефона	
		if (s[2] === "+") {
			s = s.substring(3);
			inp.value = s;
		}

		if ((s[2] === '8' && s[3] === "9") || (s[2] === '7' && s[3] === '9')) {
			s = s.substring(3);
			inp.value = s;
		}
		return s.replace(RegExp('^' + prefix.replace('+', '\\+')), '').replace(/\D/g, '').substring(-rawlen, rawlen);
	}

	function parse(el) {
		var raw = rawize(el.value);
		var ret = '';
		for (var i = 0; i < raw.length; i++) {
			ret = ret + (tr[i] ? tr[i] : '') + raw[i];
		}
		var ss = el.selectionStart;
		el.value = prefix + ret;
		var callback = el.inputtel_callback;
		if (callback) {
			var eqals = false;
			if (el.dataset.oldval != "undefined" && el.dataset.oldval == prefix + raw) {
				eqals = true;
			}
			callback(rawlen == raw.length, prefix + raw, eqals, el);
		}
		//el.selectionStart = ss;
	}

	if (typeof inp == 'string') {
		//selector
		var ar = document.querySelectorAll(inp);
		for (var i = 0; i < ar.length; i++) {
			inputTel(ar[i], callback);
		}
	}

	if (inp.jquery) {
		//jquery object
		for (var i = 0; i < inp.length; i++) {
			inputTel(inp[i], callback);
		}
	}

	if ("" + inp == '[object HTMLInputElement]') {
		//init
		inp.addEventListener('keydown', inputTel);
		inp.addEventListener('keyup', inputTel);
		inp.addEventListener('change', inputTel);
		inp.addEventListener('blur', inputTel);
		inp.addEventListener('focus', inputTel);
		//input похож на change, но отрабатывает сразу
		inp.addEventListener('input', inputTel);


		if (callback) {
			inp.inputtel_callback = callback;
		}
//		inp.onkeydown = inputTel;
//		inp.onkeyup = inputTel;
//		inp.onchange = inputTel;
		parse(inp);
		if (inp.value == prefix) {
			inp.value = '';
		}
		return true;
	}

	if (inp.type == 'focus') {
		if (inp.target.value == '') {
			inp.target.value = prefix;
		}
	}
	if (inp.type == 'blur') {
		if (inp.target.value == prefix) {
			inp.target.value = '';
		}
	}
	if (inp.type == 'change') {
		console.log('change;');
		parse(inp.target);
		return true;
	}
	//if (inp.type == 'input') {
	//console.log('input;');
	//parse(inp.target);
	//return true;
	//}
	if (inp.type == 'keyup') {
		parse(inp.target);
	}
	if (inp.type == 'keydown') {
		iic = inp;
		if (inp.keyCode == 8) {
			//backspace
			if (inp.target.value == prefix) {
				inp.preventDefault();
				return false;
			}
		}
		if (inp.keyCode === 86 && inp.ctrlKey === true) {
			return true;
		}
		if (inp.key !== undefined && inp.key.length > 1) {
			return true;
		}
		if (!/^\d$/.test(inp.key) || rawize(inp.target.value).length >= rawlen) {
			inp.preventDefault();
			return false;
		}
	}
}
*/

$("#find").on('keypress', function () {
	find_str = $("#find").val();
	aAlert(Auto(find_str));
});


/** делаем из инпута шаблон для ввода ФИО
 *  новая версия находится в jquery.inputFIO.js
 * @param {type} inp
 * @returns {Boolean}
 */
//function inputFIO(inp, words) {
//	if (typeof (words) === "undefined") {
//		words = 3;
//	}
//	if (inp.type && inp.target) {
//		words = inp.target.words;
//	}
//	var rawlen = words * 30;
//	
//	// не дает ввести невалидный символ
//	function isValidChar(char) {
//		return !/[^-\ а-яА-Яё]/.test(char);
//	}
//	
//	// дает ввести невалид в необычных ситуациях, но после проверки удаляет
//	function rawize(s) {
//		s = s.replace(/\s{2,}/g, ' ');  // убирает двойной пробел
//		s = s.replace(/\-{2,}/g, '-');  // убирает двойное тире
//		s = s.trimStart(); // убирает пробел в самом начале
//		
//		if (s.length > rawlen) {
//			s = s.substring(0, rawlen);
//			inp.value = s;
//		}
//
//		return s;
//	}
//
//	function parse(el) {
//		var raw = rawize(el.value);
//		var ret = '';
//		var raw_arr = raw.split(' ');
//		
//		// цикл для каждого слова
//		for (var n = 0; n < raw_arr.length && n < words; n++) {
//			// цикл для каждого символа
//			for (var i = 0; i < raw_arr[n].length; i++) {
//				var char = raw_arr[n][i];
//				
//				if (i === 0 && char === '-') {
//					char = '';
//				} else if (i === 0) {
//					char = char.toUpperCase();
//				} else {
//					char = char.toLowerCase();
//				}
//				
//				ret = ret + char;
//			}
//			if (n < raw_arr.length - 1 && n < words - 1) {
//				ret = ret + ' ';
//			}
//		}
//
//		var ss = el.selectionStart;
//		el.value = ret;
//		el.selectionStart = ss;
//	}
//
//	if (typeof inp === 'string') {
//		//selector
//		var ar = document.querySelectorAll(inp);
//		for (var i = 0; i < ar.length; i++) {
//			inputFIO(ar[i], words);
//		}
//	}
//
//	if (inp.jquery) {
//		//jquery object
//		for (var i = 0; i < inp.length; i++) {
//			inputFIO(inp[i], words);
//		}
//	}
//
//	if ("" + inp === '[object HTMLInputElement]') {
//		//init
//		inp.addEventListener('keydown', inputFIO);
//		inp.addEventListener('keyup', inputFIO);
//		inp.addEventListener('change', inputFIO);
//		inp.addEventListener('blur', inputFIO);
//		inp.addEventListener('focus', inputFIO);
//		//input похож на change, но отрабатывает сразу
//		inp.addEventListener('input', inputFIO);
//		// обработка значений перед вводом
//		inp.addEventListener('beforeinput', inputFIO);
//
//		inp.words = words;
////		if (callback) {
////			inp.inputtel_callback = callback;
////		}
//
//		parse(inp);
////		if (inp.value == prefix) {
////			inp.value = '';
////		}
//		return true;
//	}
//	
//	const allowedInputTypes = [
//		'deleteContentBackward', // удаление символа назад (Backspace)
//		'deleteContentForward', // удаление вперёд (Delete)
//		'historyUndo', // отмена последнего действия (ctrl z)
//		'historyRedo', // повтор последнего действия (ctrl y)
//		'deleteByCut' // удаление вырезанием
//	];
//	
//	if (inp.type === 'beforeinput') {
//		// проверка на валидность перед вводом: исключения содержатся в allowedInputTypes
//		if(!isValidChar(inp.data) && !allowedInputTypes.includes(inp.inputType)) {
//			inp.preventDefault();	
//			return false;
//		}
//		
//		return true;
//		
//	}
//
////	if (inp.type === 'focus') {
////
////	}
////	if (inp.type === 'blur') {
////
////	}
//
//	if (inp.type === 'change') {
//		parse(inp.target);
//		return true;
//	}
//	if (inp.type === 'keyup') {
//		parse(inp.target);
//	}
//	if (inp.type === 'keydown') {
//		if (inp.keyCode == 8) {
//			//backspace
//		}
//		if (inp.keyCode === 86 && inp.ctrlKey === true) {
//			return true;
//		}
//		if (inp.key.length > 1) {
//			return true;
//		}
//	}
//}


function mAlert(msg, callback) {
	aAlert(msg).then(() => {
		if (callback) {
			callback();
		}
	});
}

function formatBytes(a, b) {
	if (0 == a)
		return "0 байт";
	var c = 1024, d = b || 2, e = ['байт', 'Kб', 'Мб', 'Гб', 'Тб'], f = Math.floor(Math.log(a) / Math.log(c));
	return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
}


function putlog(level, message, error) {
	$.post("/jsputlog/" + jsloghash, {"msg": message, "level": level, "trace": error.stack});
	return true;
}

function handleWindowError(message, url, line, col, error) {
	try {
		if (typeof jslog != 'undefined' && jslog) {
			if (!error) {
				error = new Error();
			}
			putlog(5000, "browser: " + browser + "\n" + message, error);
		}
		if (typeof test_platform != 'undefined' && test_platform) {
			aAlert(message);
		}

	} catch (Exception) {
		console.log();
	}
}

window.onerror = handleWindowError;

//аудио оповещение
//var audioPlay = (function () {
//
//	var audio = new Audio();
//	audio.src = '/css/darkblue/images/Music.wav';
//
//	return function () {
//		audio.play();
//	};
//
//})();

const readyGo = function () {
	//массив элементов для галереи
	let elements = []
	//массив data атрибутов для поиска элементов(фото)
	let arrEvents = ['a[data-lightbox]', 'area[data-lightbox]'];

	//находим все элементы по массиву arrEvents
	for (let i = 0; i < arrEvents.length; ++i) {
		let event = arrEvents[i];
		let help_event = document.querySelectorAll(event);
		if (help_event !== [] && help_event !== undefined && help_event !== null) {
			for (let i = 0; i < help_event.length; ++i) {
				elements.push(help_event[i])
			}
		}
	}

	//массив для елементов из найденых с одинаковым data атрибутом ( присваиватся группе элементов )
	let elementData;

	//при клие на фото и срабатывании эвента - данная функция отключает дефолтное поведение ссылки
	function preventDef(event) {
		event.preventDefault();
	}

	//по клику срабатывает и проверяет что за элемент , добавляет в elementData все элементы из группы
	function dataAtributt(e) {

		let count_attribut = {};
		count_attribut = e.currentTarget.dataset;

		if (e.currentTarget.tagName === "A") {
			elementData = document.querySelectorAll('a[data-lightbox=' + count_attribut.lightbox + ']');
		}

		if (e.currentTarget.tagName === "AREA") {
			elementData = document.querySelectorAll('area[data-lightbox=' + count_attribut.lightbox + ']');
		}

		elementData = Array.prototype.slice.call(elementData);
	}

	for (let i = 0; i < elements.length; ++i) {
//            console.log(elements[i]);
		let el = elements[i];
		el.addEventListener('click', function (e) {
			preventDef(e);
			dataAtributt(e);
			//номер кликнутого 
			let index = elementData.indexOf(e.currentTarget);
			//вызов галереи
			photoAlbom(index, elementData);

		}, false)
	}
}

document.addEventListener("DOMContentLoaded", readyGo);


/**
 *  Загрузка данных по ИНН
 * @param {type} target
 * @param {type} silent
 * @returns {undefined|Boolean}
 */
function getPartyData(target, silent, callback) {
	var is_party_data_autofilled = strToBool($("[data-is_party_data_autofilled]", target).val());
	if (silent && !is_party_data_autofilled) {
		return;
	}


	var inn = $('[data-party-inn]', target).val();
	var party_type = $(".party-type", target).val();
	if (party_type == "100731702") {
		//FIZ
		return;
	}
	if (!validateInn(inn, {})) {
		if (!silent) {
			aAlert("Некорректный ИНН!");
		} else {
			if (is_party_data_autofilled) {
				$('[data-party]', target).val("");
				$('[data-party]', target).removeClass("invalid");
			}
		}
		return;
	}

	if (party_type == "100731703" && inn.length == 12) {
		//ur
		aAlert("Укажите ИНН юридического лица!");
		return;
	}

	if (party_type == "100679729" && inn.length == 10) {
		//ur
		aAlert("Укажите ИНН индивидуального предпринимателя!");
		return;
	}

	$(".loading", target).show();

	jQuery.ajax({
		type: 'POST',
		url: '/ajax/getPartyData',
		timeout: 3000,
		dataType: 'json',
		data: {
			inn: inn,
			sid: sid
		},
		success: function (data) {
			console.log(data);
			$(".loading", target).hide();
			if (data.error) {
				aAlert(data.error).then(() => {
					editPartyData(target);
				});
				return;
			}

			if (data) {

				for (var param in data) {
					$('input[data-party=' + param + ']', target).val(data[param]);
					$('span[data-party=' + param + '], div[data-party=' + param + ']', target).html(data[param]);
				}

//				$('[data-party=ogrn]', target).val(data.ogrn);
//				$('[data-party=kpp]', target).val(data.kpp);
//				$('[data-party=short_name]', target).val(data.short_name);
//				$('[data-party=full_name]', target).val(data.full_name);
//				$('[data-party=adres]', target).val(data.adres);
//
//				$('[data-party=imya]', target).val(data.imya);
//				$('[data-party=famil]', target).val(data.famil);
//				$('[data-party=otch]', target).val(data.otch);
//				$('[data-party=title]', target).val(data.title);

				$("input[data-party]", target).attr("readonly", true);
				$('[data-party]', target).removeClass("invalid");

				$(".check-party", target).show();

				$("[data-is_party_data_autofilled]", target).val("1");
				$(".autofill-auto-btn", target).hide();
				$(".autofill-manual-btn", target).show();

				$(".check-party-upper").css({"text-transform": "uppercase"});
				$(".check-party-upper").each(function (n, el) {
					$(el).html($(el).html().replaceAll('«', '"').replaceAll('»', '"'));
				});

				if (data.status != "ACTIVE") {
					$('[data-party=status_name]', target).css({color: 'red'});
				}

				if (callback) {
					callback(data);
				}

			} else {
				editPartyData(target, false, "Ошибка получения данных, заполнить поля вручную?");
			}
		},
		error: function (exception) {
			$(".loading", target).hide();
			console.log("ERRRR", exception);
			editPartyData(target, false, "Ошибка получения данных, заполнить поля вручную?");
		}
	});
	return false;
}


function editPartyData(target, quiet = false, confirmText = "Вы действительно хотите ввести реквизиты вручную?") {
	if (!quiet) {
		// повторяем весь код ниже, но в обертке then
		aConfirm(confirmText).then((response) => {
			if (response) {
				$("[data-is_party_data_autofilled]", target).val("0");
				$("[data-is_party_data_autofilled]", target)[0].dispatchEvent(new Event('input', { bubbles: true }));
				$("[data-party]", target).removeAttr("readonly");
				$(".autofill-manual-btn", target).hide();
				$(".autofill-auto-btn", target).show();
			}
		});
		return false;
	}
	$("[data-is_party_data_autofilled]", target).val("0");
	$("[data-is_party_data_autofilled]", target)[0].dispatchEvent(new Event('input', { bubbles: true }));
	$("[data-party]", target).removeAttr("readonly");
	$(".autofill-manual-btn", target).hide();
	$(".autofill-auto-btn", target).show();
	return false;
}

function copyTextToBufer(text) {
	let tmp = document.createElement('INPUT');
	var focus = document.activeElement;

	tmp.value = text;
	tmp.style = "position:absolute;left:-5000px;";
	document.body.appendChild(tmp);
	tmp.select();
	try {
		document.execCommand('copy');
	} catch (err) {
		console.log('Can`t copy, boss');
		aAlert("Ошибка копирования");
	}
	document.body.removeChild(tmp);
	focus.focus();
	return true;
}

if (!String.prototype.startsWith) {
	Object.defineProperty(String.prototype, 'startsWith', {
		enumerable: false,
		configurable: false,
		writable: false,
		value: function (searchString, position) {
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		}
	});
}
if (!String.prototype.endsWith) {
	Object.defineProperty(String.prototype, 'endsWith', {
		value: function (searchString, position) {
			var subjectString = this.toString();
			if (position === undefined || position > subjectString.length) {
				position = subjectString.length;
			}
			position -= searchString.length;
			var lastIndex = subjectString.indexOf(searchString, position);
			return lastIndex !== -1 && lastIndex === position;
		}
	});
}


function secToTime(allsec, min) {
	var long = !min;
	function add0(x) {
		if (x < 10 && x >= 0)
			return "0" + x * 1;
		return x;
	}

	var days = Math.floor(allsec / 60 / 60 / 24);
	var hrs = Math.floor((allsec / 60 / 60)) % 24;
	var min = Math.floor((allsec / 60)) % 60;
	var sec = Math.floor(allsec) % 60;

	return (days ? days + " дн. " : "") + (hrs || long ? add0(hrs) + ":" : "") + add0(min) + ":" + add0(sec);
}


/**
 *
 *  Base64 encode / decode
 *  http://www.webtoolkit.info/
 *
 **/
var Base64 = {

	// private property
	_keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

	// public method for encoding
	encode: function (input) {
		var output = "";
		var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
		var i = 0;

		input = Base64._utf8_encode(input);

		while (i < input.length) {

			chr1 = input.charCodeAt(i++);
			chr2 = input.charCodeAt(i++);
			chr3 = input.charCodeAt(i++);

			enc1 = chr1 >> 2;
			enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
			enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
			enc4 = chr3 & 63;

			if (isNaN(chr2)) {
				enc3 = enc4 = 64;
			} else if (isNaN(chr3)) {
				enc4 = 64;
			}

			output = output +
				this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
				this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
		}
		return output;
	},

	// public method for decoding
	decode: function (input) {
		var output = "";
		var chr1, chr2, chr3;
		var enc1, enc2, enc3, enc4;
		var i = 0;

		input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

		while (i < input.length) {

			enc1 = this._keyStr.indexOf(input.charAt(i++));
			enc2 = this._keyStr.indexOf(input.charAt(i++));
			enc3 = this._keyStr.indexOf(input.charAt(i++));
			enc4 = this._keyStr.indexOf(input.charAt(i++));

			chr1 = (enc1 << 2) | (enc2 >> 4);
			chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
			chr3 = ((enc3 & 3) << 6) | enc4;

			output = output + String.fromCharCode(chr1);

			if (enc3 != 64) {
				output = output + String.fromCharCode(chr2);
			}
			if (enc4 != 64) {
				output = output + String.fromCharCode(chr3);
			}
		}

		output = Base64._utf8_decode(output);

		return output;
	},

	// private method for UTF-8 encoding
	_utf8_encode: function (string) {
		string = string.replace(/\r\n/g, "\n");
		var utftext = "";

		for (var n = 0; n < string.length; n++) {

			var c = string.charCodeAt(n);

			if (c < 128) {
				utftext += String.fromCharCode(c);
			} else if ((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			} else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}
		}
		return utftext;
	},

	// private method for UTF-8 decoding
	_utf8_decode: function (utftext) {
		var string = "";
		var i = 0;
		var c = c1 = c2 = 0;

		while (i < utftext.length) {

			c = utftext.charCodeAt(i);

			if (c < 128) {
				string += String.fromCharCode(c);
				i++;
			} else if ((c > 191) && (c < 224)) {
				c2 = utftext.charCodeAt(i + 1);
				string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
				i += 2;
			} else {
				c2 = utftext.charCodeAt(i + 1);
				c3 = utftext.charCodeAt(i + 2);
				string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
				i += 3;
			}
		}
		return string;
	}
}

if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, "includes", {
		enumerable: false,
		value: function (obj) {
			var newArr = this.filter(function (el) {
				return el == obj;
			});
			return newArr.length > 0;
		}
	});
}

/** В первом массиве есть ВСЕ элементы второго
 * 
 * @param {type} array1 [1,2,3,4]
 * @param {type} array2 [1,2,3]
 * @returns {undefined} true
 */
function arrayContainsAll(array1, array2) {
	return array2.every(function (el) {
		return array1.includes(el);
	});
}


/** В первом массиве есть ХОТЯ БЫ ОДИН элемент второго
 * 
 * @param {type} array1 [1,2]
 * @param {type} array2 [1,2,3]
 * @returns {undefined} true
 */
function arrayContainsSome(array1, array2) {
	return array2.some(function (el) {
		return array1.includes(el);
	});
}


/** Массивы содержат одинаковые элементы
 * 
 * @param {type} array1
 * @param {type} array2
 * @returns {undefined}
 */
function arrayEquals(array1, array2) {
	return array1 && array2 && isArray(array1) && isArray(array2) && array1.sort().join('^') === array2.sort().join('^');
}

function setCookie(cname, cvalue, exdays) {
	var expires = "";
	if (exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		expires = "expires=" + d.toUTCString();
	}
	document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ')
			c = c.substring(1);
		if (c.indexOf(name) != -1)
			return c.substring(name.length, c.length);
	}
	return "";
}


/**
 * 
 * @param {Date} d
 * @returns {Boolean}
 */
function isValidDate(d) {
	return d instanceof Date && !isNaN(d);
}

function lotSubscribeToggle(event, lot_id) {
	event.stopPropagation();
	event.preventDefault();
	jQuery.post("/lotSubscribe?lot_id=" + lot_id + "&alreadySubbed=toggle", function (data) {
		var block_lot = $(".favourites[data-lotId='" + data.lot_id + "']");
		if (data.success) {
			if (data.event == "subscribe") {
				$(".subscribe-buttons .subscribe-button", block_lot).removeClass("subscribe-on").addClass("subscribe-use");
				$(".subscribe-buttons .subscribe-button", block_lot).tooltip({content: 'Убрать Лот из Избранного'});
				$(".subscribe-buttons-big .subscribe-button", block_lot).removeClass("subscribe-on").addClass("subscribe-use");
				$(".subscribe-buttons-big .subscribe-button", block_lot).attr("title", "Убрать Лот из Избранного");
				$(".subscribe-buttons-big .subscribe-button", block_lot).tooltip({content: 'Убрать Лот из Избранного'});

			} else {
				$(".subscribe-buttons .subscribe-button", block_lot).removeClass("subscribe-use").addClass("subscribe-on");
				$(".subscribe-buttons .subscribe-button", block_lot).tooltip({content: 'Добавить Лот в Избранное'});
				$(".subscribe-buttons-big .subscribe-button", block_lot).removeClass("subscribe-use").addClass("subscribe-on");
				$(".subscribe-buttons-big .subscribe-button", block_lot).attr("title", "Добавить Лот в Избранное");
				$(".subscribe-buttons-big .subscribe-button", block_lot).tooltip({content: 'Добавить Лот в Избранное'});

			}
			var old_counter = parseInt($("#subscription_counter").attr("data-counter"));
			if (isNaN(old_counter)) {
				old_counter = 0;
			}
			if (data.event == "unsubscribe") {
				old_counter--;
			} else {
				old_counter++;
			}
			if (old_counter < 0) {
				old_counter = 0;
			}
			if (old_counter === 0) {
				$("#subscription_counter").hide();
			} else {
				$("#subscription_counter").show();
			}
			$("#subscription_counter").attr({"data-counter": old_counter});
			$("#subscription_counter").html(old_counter);
		} else {
			aAlert(data.message);
		}
	});
}
function declOfNum(n, text_forms) {
	n = Math.abs(n) % 100;
	var n1 = n % 10;
	if (n > 10 && n < 20) {
		return text_forms[2];
	}
	if (n1 > 1 && n1 < 5) {
		return text_forms[1];
	}
	if (n1 == 1) {
		return text_forms[0];
	}
	return text_forms[2];
}

function getHashValue(name) {
	var value = "";
	if (window.location.hash) {
		var hash = window.location.hash.substring(1);
		var hashArray = hash.split("&");
		for (var idx in hashArray) {
			var ha = hashArray[idx].split("=");
			var hashname = ha[0];
			var hashvalue = ha[1];
			if (name === hashname) {
				value = hashvalue;
				break;
			}
		}
	}
	return value;
}

function setHashValue(name, value) {
	var newHash = "";
	if (window.location.hash) {
		var hash = window.location.hash.substring(1);
		var hashArray = hash.split("&");
		if (typeof hashArray.find((element) => element.split("=")[0] === name) === "undefined") {
			hashArray.push(name + "=" + value);
		}
		//удаляем одинаковые значения
		hashArray = [...new Set(hashArray)].sort();
		for (var idx in hashArray) {
			var ha = hashArray[idx].split("=");
			var hashname = ha[0];
			var hashvalue = ha[1];
			if (hashArray.filter((element) => element.split("=")[0] === hashname).indexOf(hashArray[idx]) > 0) {
				//удаляет одинаковые параметры с разными занчениями
				continue;
			}
			newHash += (newHash.length > 0 ? "&" : "") + hashname + "=" + (hashname === name ? value : hashvalue);
		}
	} else {
		newHash = name + "=" + value;
	}
	window.history.replaceState(null, null, "#" + newHash);
	window.dispatchEvent(new Event("hashchange"));
//	window.history.pushState(null, null, "#" + newHash);
//	window.location.hash = "#" + newHash;
}

/**
 * Получение реквизитов банка при вводе наименования или БИК через библиотеку suggestions
 * @param {type} selector - селектор
 * @param {type} bank
 * @param {type} bik
 * @param {type} ks
 * @param {type} rs
 * @returns {undefined}
 */
function bankDetails(selector, bank, bik, ks, rs) {
	var plugin_bank = $("[name=" + bank + "]", selector).suggestions({
		//token: Conf.get("dadata_token"),
		type: "BANK",
		onSelectNothing: function () {
			$("[name=" + rs + "]").val("");
			$("[name=" + bik + "]").val("");
			$("[name=" + ks + "]").val("");
			if ($(this).val().length === 0) {
				$(this).removeClass('invalid').removeClass('valid');
			} else {
				$(this).removeClass('valid').addClass('invalid');
			}
		},
		/* Вызывается, когда пользователь выбирает одну из подсказок */
		onSelect: function (suggestion) {
			if (suggestion) {
				$(this).removeClass('invalid').addClass('valid');
				$("[name=" + bik + "]").val(suggestion.data.bic);
				var ksch = suggestion.data.correspondent_account;
				if (!ksch && suggestion.data.treasury_accounts) {
					ksch = suggestion.data.treasury_accounts[0];
				}
				$("[name=" + ks + "]").val(ksch);
			} else {
				$(this).removeClass('valid').addClass('invalid');
				$("[name=" + bank + "]").val("");
			}
		},
		onSearchError: function () {
			$("[name=" + bik + "]").removeAttr("readonly");
			$("[name=" + ks + "]").removeAttr("readonly");
			plugin_bank.hide();
		},
		
		onSuggestionsFetch: function (suggestionsArray) {
			//console.log(suggestionsArray, 'suggestionsArray')
			
			// Преобразуем в формат DaData
			return suggestionsArray.map(function (item) {
				var ksch = item.correspondent_account;
				if (!ksch && item.treasury_accounts?.[0]) {
					ksch = item.treasury_accounts[0];
				}

				return {
					value: item.name_p || item.name,
					unrestricted_value: item.name_p || item.name,
					data: {
						bic: item.bik,
						inn: item.inn || "",
						kpp: item.kpp || "",
						correspondent_account: ksch,
						treasury_accounts: item.treasury_accounts,
						name: {payment: item.name_p || item.name},
						address: {
							value: item.adr || item.address || "",
							unrestricted_value: item.adr || item.address || ""
						},
						opf: {type: "BANK"},
						state: {status: "ACTIVE"}
					}
				};
			});
		},
		
		geoLocation: false, // отключаем возврат списка по геолокации (у нас на бэке это даже не реализовано, если что)
		notSuggestionResponseFormat: true, // получаем не suggestion, а data объект
		serviceUrl: "/ajax/api/banks_data",
	}).suggestions();
}

function residentialComplexDetails(selector, fieldName) {
	var serviceUrl = '/ajax/api/residential_complexes_data';

	function getItemTitle(item) {
		return item.name || ('ЖК #' + item.cian_id);
	}

	function getItemAddress(item) {
		return item.matching_house_address || item.address || '';
	}

	function getSuggestionLabel(item) {
		var displayId = item.matching_house_id || item.cian_id;
		var complexHint = item.matching_house_id ? (' | ЖК ' + item.cian_id) : '';
		var address = getItemAddress(item);
		return displayId + complexHint + ' | ' + getItemTitle(item)
			+ (address ? ' | ' + address : '')
			+ (item.region ? ' | ' + item.region : '');
	}

	function setInputState($input, state) {
		if (state === 'valid') {
			$input.removeClass('invalid').addClass('valid');
			return;
		}
		if (state === 'typing') {
			$input.removeClass('valid');
			return;
		}
		if (state === 'empty') {
			$input.removeClass('invalid').removeClass('valid');
			return;
		}
		$input.removeClass('valid').addClass('invalid');
	}

	function clearSelection($input, $hidden) {
		$hidden.val('');
		setInputState($input, $input.val().length === 0 ? 'empty' : 'invalid');
	}

	function applySuggestion($input, $hidden, suggestion) {
		if (suggestion && suggestion.data && suggestion.data.cian_id) {
			$hidden.val(String(suggestion.data.cian_id));
			$input.val(suggestion.value || '');
			setInputState($input, 'valid');
			return;
		}
		clearSelection($input, $hidden);
	}

	function preloadSelectedValue($input, $hidden) {
		if (!$hidden.val()) {
			return;
		}

		jQuery.ajax({
			url: serviceUrl,
			method: 'get',
			dataType: 'json',
			data: {query: $hidden.val(), count: 1},
			success: function (response) {
				var item = response && response.data && response.data.length ? response.data[0] : null;
				if (item) {
					$input.val(getSuggestionLabel(item));
					setInputState($input, 'valid');
				}
			}
		});
	}

	function mapSuggestion(item) {
		var title = getItemTitle(item);
		var address = getItemAddress(item);
		var label = getSuggestionLabel(item);
		return {
			value: String(label || ''),
			unrestricted_value: String(label || ''),
			data: {
				cian_id: String(item.cian_id || ''),
				matching_house_id: String(item.matching_house_id || ''),
				name: {payment: String(title || '')},
				address: {
					value: String(address || ''),
					unrestricted_value: String(address || '')
				},
				region: String(item.region || ''),
				matching_house_address: String(item.matching_house_address || ''),
			}
		};
	}

	$('[name="' + fieldName + '"]', selector).each(function () {
		var $hidden = $(this);
		var $input = $hidden.siblings('[name="cian_jkschema_title[]"]').first();
		var plugin_residential;

		if (!$input.length || $input.data('residential-complex-init')) {
			return;
		}

		$input.data('residential-complex-init', true);

		$input.on('input', function () {
			$hidden.val('');
			setInputState($(this), $(this).val().length === 0 ? 'empty' : 'typing');
		});

		preloadSelectedValue($input, $hidden);

		plugin_residential = $input.suggestions({
			type: "ADDRESS",
			showUnrestricted: false,
			noSuggestionsHint: "Неизвестный ЖК",
			onSelectNothing: function () {
				clearSelection($(this), $hidden);
			},
			onSelect: function (suggestion) {
				applySuggestion($(this), $hidden, suggestion);
			},
			onSearchError: function () {
				plugin_residential.hide();
			},
			formatResult: function (value, currentValue, suggestion) {
				var address = (suggestion.data.address && suggestion.data.address.value)
					|| suggestion.data.matching_house_address
					|| '';
				var meta = [suggestion.data.region || '', address].filter(Boolean).join(' | ');
				return suggestion.value + (meta ? '<br><small>' + meta + '</small>' : '');
			},
			formatSelected: function (suggestion) {
				return suggestion && suggestion.value ? String(suggestion.value) : '';
			},
			onSuggestionsFetch: function (suggestionsArray) {
				return suggestionsArray.map(mapSuggestion);
			},
			geoLocation: false,
			notSuggestionResponseFormat: true,
			serviceUrl: serviceUrl
		}).suggestions();
	});
}
function closeHeaderMessage($msg_id) {
	jQuery.ajax({
		url: '/attachedMessagesList',
		method: 'get',
		dataType: 'html',
		data: {msg_id: $msg_id},
		success: function (data) {
			if ($msg_id == data) {
				document.getElementById("header_popup_message_" + data).remove();
			}
		}
	});
}

// передаем информацию о том, что кликнули после авторизации
jQuery(function () {
	var clickElementSelector = getCookie("clickElementOnPostAuth");
	if (clickElementSelector.length > 0) {
		if (isAuth) {
			if (jQuery(clickElementSelector).length > 0) {
				jQuery(clickElementSelector)[0].click();
			}
			setCookie("clickElementOnPostAuth", '');
		}
	}
});

function clickTopTorgi(el) {
	jQuery.post("ajax/topView", "topId=" + id, function (data) {
		window.location = el.href;
	});
	return false;
}
function getTopTorgiCategory() {
	var initCategory = "all";
	var hashCategory = getHashValue("category");
	return (hashCategory.length > 0 ? hashCategory : initCategory);
}
function getViewType() {
	var initViewType = "tile";
	var hashViewType = getHashValue("viewtype");
	return (hashViewType.length > 0 ? hashViewType : initViewType);
}
function setResult(count) {
	jQuery(".soc_result .counter").html(count);
	jQuery(".soc_result .title").html(declOfNum(count, ["объявление", "объявления", "объявлений"]));
}
function updateTopTorgi(categoryName, viewType, is_animate) {
	$("input[name='so-type']").prop({"checked": false});
	$("input[name='so-type'][value='" + categoryName + "']").prop({"checked": true});
	$("select[name='so-type_selector']").val(categoryName);
	jQuery("input[name='so-format-type']").prop({"checked": false});
	jQuery("input[name='so-format-type'][value='" + viewType + "']").prop({"checked": true});
	var hideLength = jQuery(".soc_body .card-so:visible, .soc_body .top_torgy_empty:visible").length;
	var showSelector = ".soc_body .card-so";
	if (categoryName !== "all") {
		showSelector += "[data-category='" + categoryName + "']";
	}
	var showLength = jQuery(showSelector).length;
	if (showLength === 0) {
		showSelector = ".soc_body .top_torgy_empty";
	}
	if (is_animate) {
		jQuery(".soc_result:visible").fadeOut(400, function () {
			setResult(showLength);
			jQuery(".soc_result").fadeIn(400);
		});
		if (hideLength > 0) {
			jQuery(".soc_body:visible").fadeOut(400, function () {
				jQuery(".soc_body .card-so, .soc_body .top_torgy_empty").hide();
				jQuery(".soc_body").removeClass("tile").removeClass("list").addClass(viewType);
				jQuery(showSelector).show();
				jQuery(".soc_body").fadeIn(400);
			});
		} else {
			jQuery(".soc_body").hide().removeClass("tile").removeClass("list").addClass(viewType);
			jQuery(".soc_body .card-so, .soc_body .top_torgy_empty").hide();
			jQuery(showSelector).show();
			jQuery(".soc_body").fadeIn(400);
		}
		return;
	} else {
		setResult(showLength);
		jQuery(".soc_body").removeClass("tile").removeClass("list").addClass(viewType);
	}
	jQuery(".soc_body .card-so:visible, .soc_body .top_torgy_empty:visible").hide();
	jQuery(showSelector).show();
}
String.prototype.toGoskeyFileName = function () {
	const pattern = Conf.get("goskey_allowed_file_chars_pattern");
	const rs = new RegExp(pattern, 'g');
//	var filename = this.replaceAll(rs, '');
	var filename = this.replaceAll("ё", "е").replaceAll("Ё", "Ё").replaceAll(rs, '');
	const ext = filename.split('.').pop().toLowerCase();
	return filename.substring(0, filename.length - ext.length) + ext;
};


async function countdown(selector, callback) {
	const el = $(selector);
	const totalTime = $(selector).attr('data-seconds');
	if (!totalTime) {
		return false;
	}
	var startTime = performance.now();
	var leftTime;
	while ((typeof leftTime === "undefined" || leftTime > 0) && el.is(":visible")) {
		leftTime = totalTime - (performance.now() - startTime) / 1000;
		el.html(secToTime(Math.round(leftTime), true));
		const delta = (leftTime - (Math.round(leftTime) - 1)) * 1000;
		await sleep(delta);
	}
	if (leftTime <= 0) {
		leftTime = 0;
		el.html(secToTime(Math.round(leftTime), true));
		el.data("countdown-startTime", null);
		if (typeof callback === "function") {
			callback();
		}
	}

}
function beforeunloadFunc(event) {
	event.preventDefault();
	event.returnValue = true;
}

function debugConsoleLog() {
	const date = new Date();
	const dateString = date.toISOString();
	var castomConsole = document.getElementById("debug-console");
	if (!castomConsole) {
		castomConsole = document.createElement("div");
		castomConsole.id = "debug-console";
		castomConsole.classList.add("debug-console");
		document.body.appendChild(castomConsole);
	}
	var message = document.createElement("div");
	message.classList.add("message");
	var timer = document.createElement("div");
	timer.classList.add("time");
	timer.innerHTML = dateString;
	message.appendChild(timer);
	for (var i = 0; i < arguments.length; i++) {
		var child = document.createElement("div");
		child.classList.add("argument");
		var text = arguments[i];
		if (typeof text === "object") {
			text = text + ":" + stringifyEvent(text);
		}
		child.innerHTML = text;
		//JSON.stringify()
		message.appendChild(child);
	}
	castomConsole.appendChild(message);
	castomConsole.scrollTop = castomConsole.scrollHeight;
	setTimeout(fadeOutAndRemove.bind(this, message), 10000);
}
function fadeOutAndRemove(element) {
	element.classList.add('fade-out');
	element.addEventListener('transitionend', function () {
		element.parentNode.removeChild(element);
	});
}
function stringifyEvent(e) {
	const obj = {};
	for (let k in e) {
		obj[k] = e[k];
	}
	return JSON.stringify(obj, (k, v) => {
		if (v instanceof Node)
			return 'Node';
		if (v instanceof Window)
			return 'Window';
		return v;
	}, ' ');
}

/**
 * Проверка на совершеннолетие по дате рождения
 * @param {string} date - дата рождения в формате DD.MM.YYYY
 * @returns {boolean} true если совершеннолетний, false если нет
 * @throws {Error} false если дата некорректна
 */
function isAdult(date) {
	try { // если не можем преобразовать или некорретная дата то false
		
		// Проверяем корректность даты
		if (!validateDate(date)) {
			throw new Error("");
		}
		
		// Парсим дату
		const datePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
		const match = date.match(datePattern);

		const day = Number.parseInt(match[1], 10);
		const month = Number.parseInt(match[2], 10) - 1;// месяцы начинаются с 0
		const year = Number.parseInt(match[3], 10);

		// Создаем объекты дат
		const birthDateObj = new Date(year, month, day);
		const currentDate = new Date();

		// Вычисляем точный возраст
		let age = currentDate.getFullYear() - birthDateObj.getFullYear();

		// Проверяем, наступил ли день рождения в этом году
		const monthDiff = currentDate.getMonth() - birthDateObj.getMonth();
		const dayDiff = currentDate.getDate() - birthDateObj.getDate();

		// Если месяц рождения еще не наступил, или наступил но день рождения еще не прошел
		if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
			age--;
		}

		return age >= 18;
	
	} catch(e) { 
		// При любой ошибке — возвращаем false
		//aAlert("Некорректная дата рождения");
		return false;
	}
}

/**
 * Получить минимальную дату рождения для совершеннолетия
 * @returns {string} минимальная дата рождения в формате DD.MM.YYYY для совершеннолетнего человека
 */
function getMinAdultDate() {
  const currentDate = new Date();

  // Отнимаем 18 лет от текущей даты
  const minBirthDate = new Date(currentDate);
  minBirthDate.setFullYear(minBirthDate.getFullYear() - 18);

  // Форматируем результат в DD.MM.YYYY
  const day = String(minBirthDate.getDate()).padStart(2, "0");
  const month = String(minBirthDate.getMonth() + 1).padStart(2, "0"); // +1 так как месяцы начинаются с 0
  const year = minBirthDate.getFullYear();

  return `${day}.${month}.${year}`;
}

/**
 * Определяет, будущая ли дата
 * @param {type} date
 * @returns {Boolean}
 */
function isNotFutureDate(date) {
	try { // если не можем проверить или некорретная дата то false

		// Проверяем корректность даты
		if (!validateDate(date)) {
			return false;
		}

		// Парсим дату
		const datePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
		const match = date.match(datePattern);

		const day = Number.parseInt(match[1], 10);
		const month = Number.parseInt(match[2], 10) - 1;// месяцы начинаются с 0
		const year = Number.parseInt(match[3], 10);
		
		// Создаём объект даты
		const parsedDate = new Date(year, month, day);
		
		// Получаем текущую дату (без времени, только день/месяц/год)
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		
		// Сравниваем: дата не должна быть позже today (сегодняшней даты)
		return parsedDate <= today;
	} catch (e) {
		// При любой ошибке — возвращаем false
		return false;
	}
}

/**
 * Кодирует строку в URL-формат и затем возвращает некоторые символы в их исходный вид для лучшей читаемости.
 * Тот же метод что и TemplUtil.urlencode
 * @param o - строка 
 */
function urlencode(o) {
	if (!o) {
		return null;
	}

	const s = o.toString();

	try {
		return encodeURIComponent(s)
			.replace(/\+/g, '%20')
			.replace(/%21/g, '!')
			.replace(/%27/g, "'")
			.replace(/%28/g, '(')
			.replace(/%29/g, ')')
			.replace(/%7E/g, '~');
	} catch (ex) {
		return s;
	}
}

/**
 * Декодирование всех html сущностей (&quot, &lt и пр.)
 * @param {type} value
 * @returns {jQuery}
 * @note Некоторые значения velocity возвращает c html элементами, но их допустим нужно повторно отправить без них
 * @example 'ООО &quot;ПЕТУШОК&quot;' → 'ООО "ПЕТУШОК"'
 */
function htmlDecode(value) {
    value = ("" + value).replace("<script", "").replace("&lt;script", "");
    return $('<div/>').html(value).text();
}

/**
 * Получаем JSON из прокси
 * @param {type} proxy
 * @returns {Array|Object}
 */
function unpackProxy(proxy) {
	// Конвертируем Proxy в обычный массив через JSON (работает с Alpine.js Proxy)
	let filesArray = [];
	try {
		// JSON.parse(JSON.stringify()) — надёжный способ "распаковать" Proxy
		filesArray = JSON.parse(JSON.stringify(proxy.files || []));
	} catch (e) {
		console.warn('Ошибка парсинга files:', e);
		filesArray = [];
	}
	return filesArray;
}








